import axios from 'axios'

const baseURL = process.env.REACT_APP_DASH_API

const axiosDashClient = axios.create({
  baseURL,
})

export default axiosDashClient
